module.exports = __webpack_public_path__ + "img/baoZhang.04e36ab1.jpg";